import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Empty } from 'antd';
import dayjs from 'dayjs';

const TimeEvolutionChart = ({ data }) => {
  if (!data || data.length === 0) {
    return <Empty description="Nenhum dado encontrado para o período selecionado" />;
  }

  // Formatar dados para o gráfico
  const chartData = data.map(item => ({
    ...item,
    dateFormatted: dayjs(item.date).format('DD/MM')
  }));

  return (
    <ResponsiveContainer width="100%" height={400}>
      <LineChart data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="dateFormatted" />
        <YAxis yAxisId="left" />
        <YAxis yAxisId="right" orientation="right" />
        <Tooltip 
          formatter={(value, name) => {
            if (name === 'Lotes') return [value, 'Lotes'];
            if (name === 'Tambores') return [value, 'Tambores'];
            return value;
          }}
          labelFormatter={(label) => `Data: ${label}`}
        />
        <Legend />
        <Line 
          yAxisId="left"
          type="monotone" 
          dataKey="batches" 
          stroke="#1890ff" 
          name="Lotes"
          strokeWidth={2}
          dot={{ r: 4 }}
          activeDot={{ r: 6 }}
        />
        <Line 
          yAxisId="right"
          type="monotone" 
          dataKey="drums" 
          stroke="#52c41a" 
          name="Tambores"
          strokeWidth={2}
          dot={{ r: 4 }}
          activeDot={{ r: 6 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default TimeEvolutionChart;

